import { createSelector } from "@reduxjs/toolkit";

export const smsEligibilityState = (state) => state.smsEligibility;

export const smsEligibilitySelector = createSelector(smsEligibilityState, (state) => state);
